import { Box, Typography } from "@mui/material"
import { Area, SolutionRect } from "../../common/Models"
import COLORS from "../../common/FortesColors"

export default function DetailBox(props: {
  rect: SolutionRect
  allBox: Area
  currency: string
  pricePerRect: number | undefined
  spacing: number
  border: number
}): JSX.Element {
  const all =
    (props.allBox.h + props.spacing) * (props.allBox.w + props.spacing)
  const my =
    (props.rect?.w - props.spacing || 0) * (props.rect?.h - props.spacing || 0)
  const used = (my * 100) / all
  const typographySx = {
    paddingRight: "20px",
    color: COLORS.darkPurple,
    fontSize: "100%",
    fontWeight: 600,
    maxWidth: "200px",
    maxHeight: "50px",
  }

  return (
    <div
      style={{
        margin: "20px",
        width: 400,
        background: "white",
      }}
    >
      <Typography {...typographySx}>Selected object detail</Typography>

      <Cell key_="Identifier:" value={`${props.rect.id}`} />
      <Cell key_="X:" value={`${props.rect.x} mm`} />
      <Cell key_="Y:" value={`${props.rect.y} mm`} />
      <Cell key_="Width:" value={`${props.rect.w} mm`} />
      <Cell key_="Height:" value={`${props.rect.h} mm`} />
      <Cell key_="Radius:" value={`${props.rect.r} mm`} />
      <Cell key_="Object size:" value={`${my} mm²`} />
      <Cell key_="Cut-out area usage:" value={`${used.toFixed(2)} %`} />
      <Cell
        key_="Price:"
        value={`${props.pricePerRect?.toFixed(2)} ${props.currency}`}
      />
    </div>
  )
}

function Cell(props: { key_: string; value: string }): JSX.Element {
  const sx = {
    paddingRight: "20px",
    color: COLORS.darkPurple,
    fontSize: "90%",
    fontWeight: 500,
    maxWidth: "200px",
    maxHeight: "50px",
  }

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      sx={{
        paddingBlockStart: "10px",
        paddingBlockEnd: "10px",
        borderBlockEnd: `1px solid ${COLORS.separator}`,
      }}
    >
      <Typography {...sx}>{props.key_}</Typography>

      <Typography {...sx}>{props.value}</Typography>
    </Box>
  )
}
